var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 4.59999C23.1 4.99999 22.2 5.29999 21.2 5.39999C22.2 4.79999 23 3.79999 23.4 2.69999C22.4 3.29999 21.4 3.69999 20.3 3.89999C19.4 2.89999 18.1 2.29999 16.7 2.29999C14 2.29999 11.8 4.49999 11.8 7.19999C11.8 7.59999 11.8 7.99999 11.9 8.29999C7.7 8.09999 4.1 6.09999 1.7 3.09999C1.2 3.89999 1 4.69999 1 5.59999C1 7.29999 1.9 8.79999 3.2 9.69999C2.4 9.69999 1.6 9.49999 1 9.09999C1 9.09999 1 9.09999 1 9.19999C1 11.6 2.7 13.6 4.9 14C4.5 14.1 4.1 14.2 3.6 14.2C3.3 14.2 3 14.2 2.7 14.1C3.3 16.1 5.1 17.5 7.3 17.5C5.6 18.8 3.5 19.6 1.2 19.6C0.8 19.6 0.4 19.6 0 19.5C2.2 20.9 4.8 21.7 7.5 21.7C16.6 21.7 21.5 14.2 21.5 7.69999C21.5 7.49999 21.5 7.29999 21.5 7.09999C22.5 6.39999 23.3 5.49999 24 4.59999Z","fill":"white"}));
}

Twitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
